import React from 'react';
import Hero from "../components/Hero";
import AboutSection from "../components/AboutSection";
import ProductsSection from "../components/ProductsSection";
import CTASection from "../components/CTASection";

function Home() {
  return (
    <>
      <Hero />
      <AboutSection />
      <ProductsSection />
      <CTASection />
    </>
  );
}

export default Home;
